import type { FC } from "react";
import type { TeamLineupFlat } from "@motain/xpa-proto-files-web/lib/types/match_lineup";
import { isNonNullable } from "@/types/isNonNullable";
import styles from "./MatchLineupFlat.module.scss";
import classNames from "classnames";

export const MatchLineupFlat: FC<TeamLineupFlat> = (props) => {
  const { players } = props;
  return (
    <ul className={styles.container}>
      {isNonNullable(players) &&
        players.map((player) => {
          return (
            <li key={player.uiKey} className={styles.player}>
              <span className={classNames("title-7-bold", styles.playerNumber)}>
                {player.jerseyNumber}
              </span>
              {isNonNullable(player.link) ? (
                <a
                  href={player.link.urlPath}
                  className={classNames("title-7-medium", styles.playerName)}
                >
                  {player.name}
                </a>
              ) : (
                <span className={"title-7-medium"}> {player.name}</span>
              )}
            </li>
          );
        })}
    </ul>
  );
};
